import { relatedActionsVerticalIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const MoreV = createIcon({
  displayName: 'MoreV',
  d: 'M512 85.333c-47.104 0-85.333 38.229-85.333 85.333s38.229 85.333 85.333 85.333c47.104 0 85.333-38.229 85.333-85.333s-38.229-85.333-85.333-85.333zM512 426.667c-47.104 0-85.333 38.229-85.333 85.333s38.229 85.333 85.333 85.333c47.104 0 85.333-38.229 85.333-85.333s-38.229-85.333-85.333-85.333zM512 768c-47.104 0-85.333 38.229-85.333 85.333s38.229 85.333 85.333 85.333c47.104 0 85.333-38.229 85.333-85.333s-38.229-85.333-85.333-85.333z',
  canvasPaths: canvasIconPaths(relatedActionsVerticalIcon)
})
